import React, { useEffect, useState } from "react";
import LoadingFallback from "../../../common/components/LoadingFallback";
import { useParams } from "react-router";
import api from "../../../common/utils/api";
import { Alert, Box, Button, Typography } from "@mui/material";

export default function DocEdit() {
  const params = useParams();
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);
  const [url, setUrl] = useState("");

  useEffect(() => {
    api
      .get(`/fv/documents/${params.documentId}/edit-token`)
      .then((resp) => {
        const url =
          "ms-word:ofe|u|" +
          process.env.REACT_APP_API_BASE_URL +
          "/fv/documents/" +
          resp.data.token +
          "/" +
          resp.data.fileName;

        const newW = window.open(url, "_blank");
        if (newW) {
          newW.focus();
          window.close();
        } else {
          setUrl(url);
        }
      })
      .catch((err) => {
        setError(err.response?.data?.error || err.message || "Error opening document");
      })
      .finally((_) => {
        setLoading(false);
      });
  }, [params.documentId]);

  return (
    <Box sx={{ display: "flex", flexDirection: "column", width: "100%", justifyContent: "center" }}>
      <Box sx={{ display: "flex", flexDirection: "row", justifyContent: "center" }}>
        {error && <Alert color="error">{error}</Alert>}
        {!error && loading && <LoadingFallback />}
        {!error && !loading && !url && <Typography>Document opened. You can close this tab.</Typography>}
        {url && (
          <Box>
            <Button href={url} variant="contained" color="primary">
              Open Document
            </Button>
          </Box>
        )}
      </Box>
    </Box>
  );
}
